export default "__VITE_ASSET__ZyFnXcWL__"